<div class="font-align-selector">
  <div [ngSwitch]="currentFontAlign" (click)="clickHandler()">
    <nw-icon
      *ngSwitchCase="'left'"
      type="format_align_leftr"
      color="white"
    ></nw-icon>
    <nw-icon
      *ngSwitchCase="'center'"
      type="format_align_center"
      color="white"
    ></nw-icon>
    <nw-icon
      *ngSwitchCase="'right'"
      type="format_align_right"
      color="white"
    ></nw-icon>
  </div>
</div>
